module.exports = __webpack_public_path__ + "img/2.24013e51.png";